import moment from 'moment-timezone';
moment.tz.setDefault('UTC');
export const defaultMoment = moment;

export const S3_TIMEOUT = 1000 * 60; // 1 hour
export const REQUEST_TIMEOUT = 5000;
export const PROMPT_TIMEOUT = 1000 * 60 * 1; //  1 min

export const displayDateFormat = 'MM/DD/YYYY';
export const displayDateTimeFormat = 'MMMM D, YYYY [at] h:mm A zz';

export const getConfig = (key, fallback = '') =>
  window.__RUNTIME_CONFIG__?.[key] ?? import.meta.env[key] ?? fallback;

export const isTest = getConfig('REACT_APP_ENVIRONMENT') === 'test';
export const isProduction = getConfig('REACT_APP_ENVIRONMENT') === 'production';
export const isNotProduction = !isProduction;

const getApiHosts = () => [getConfig('REACT_APP_API_URL', 'http://localhost:3000')];
export const apiHosts = getApiHosts();

const effectiveApiUrl = () => {
  // circle is being weird, so just return the first/only test host
  if (isTest) return apiHosts[0];

  // default to first host
  let apiUrl = apiHosts[0];
  const authHost = window.localStorage.getItem('auth_host');

  if (authHost && apiHosts.includes(authHost)) apiUrl = authHost;
  return apiUrl;
};

// TODO: annoyingly a lot of tests are hardcoded to mock this, so leaving apiUrl as default for now
export const config = {
  apiUrl: effectiveApiUrl(),
  effectiveApiUrl,
};

export const getGladosUrl = () =>
  getConfig('REACT_APP_GLADOS_URL', 'https://account.signinapp.localhost:8080');

export const getGladosNavUrl = () =>
  getConfig('REACT_APP_GLADOS_NAV_URL');

export const signatureRequestPdfUrl = (id) => `${effectiveApiUrl()}/v2/digital_forms/${id}/pdf`;
